import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { hasSchedulerAuthorityChanged, latestSchedulerAuthorityChangedUser, SCHEDULER_AUTHORITY_CHANGED_EVENT } from '../../../../../core/services/schedulerOfflineStore';

export function SchedulerAuthorityChangedModal({ userId }: { userId?: string }) {
  const [changedUser, setChangedUser] = useState(() => userId ? hasSchedulerAuthorityChanged(userId) ? userId : null : latestSchedulerAuthorityChangedUser());
  const button = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const changed = (event: Event) => {
      const changed = (event as Event & { userId?: string }).userId;
      if (!changed) setChangedUser(null);
      else if (!userId || changed === userId) setChangedUser(changed);
    };
    if (userId && hasSchedulerAuthorityChanged(userId)) setChangedUser(userId);
    window.addEventListener(SCHEDULER_AUTHORITY_CHANGED_EVENT, changed);
    return () => window.removeEventListener(SCHEDULER_AUTHORITY_CHANGED_EVENT, changed);
  }, [userId]);
  useEffect(() => { if (changedUser && (!userId || changedUser === userId)) button.current?.focus(); }, [changedUser, userId]);
  if (!changedUser || userId && changedUser !== userId || typeof document === 'undefined') return null;
  return createPortal(<div role="alertdialog" aria-modal="true" aria-labelledby="scheduler-authority-title"
    className="modal-006-backdrop fixed inset-0 z-[10000] flex items-center justify-center bg-black/30 p-4 backdrop-blur-md"
    onKeyDown={event => { if (event.key === 'Tab' || event.key === 'Escape') { event.preventDefault(); button.current?.focus(); } }}>
    <div className="modal-006-surface w-full max-w-md rounded-2xl bg-white p-6 text-slate-900 shadow-xl">
      <p id="scheduler-authority-title" className="mb-5 text-lg font-semibold">Jogosultsága módosult, kérem frissítse az oldalt.</p>
      <button ref={button} type="button" className="rounded-xl bg-emerald-600 px-5 py-3 font-semibold text-white" onClick={() => window.location.reload()}>Oldal frissítése</button>
    </div>
  </div>, document.body);
}
